@if (company(); as active) {
  <div class="sidebar-company" [class.is-collapsed]="collapsed()">
    @if (canSwitch()) {
      <button
        type="button"
        class="company-trigger"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        aria-haspopup="menu"
        [attr.aria-expanded]="menuOpen()"
        (click)="toggleMenu()"
      >
        <ng-container
          [ngTemplateOutlet]="identity"
          [ngTemplateOutletContext]="{ $implicit: active, switchable: true }"
        />
      </button>

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="menuOpen()"
        [cdkConnectedOverlayPositions]="menuPositions"
        [cdkConnectedOverlayHasBackdrop]="true"
        cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
        cdkConnectedOverlayPanelClass="sidebar-company-overlay"
        (backdropClick)="closeMenu()"
        (detach)="closeMenu()"
      >
        <div class="company-menu" role="menu">
          <span class="company-menu__title">{{ 'sidebar.switch_company' | translate }}</span>
          @for (m of memberships(); track m.id) {
            <button
              type="button"
              class="company-menu__item"
              role="menuitemradio"
              [class.is-active]="m.company.id === active.id"
              [attr.aria-checked]="m.company.id === active.id"
              (click)="onSelect(m.company.id)"
            >
              <span class="company-menu__avatar">
                @if (m.company.logo; as logo) {
                  <img class="company-logo" [src]="logo.medium" [alt]="m.company.name" />
                } @else {
                  <span class="company-initial" aria-hidden="true">{{ initialOf(m.company.name) }}</span>
                }
              </span>
              <span class="company-menu__text">
                <span class="company-menu__name">
                  {{ m.company.name ?? ('auth.select_company.unnamed' | translate) }}
                </span>
                <span class="company-menu__role">{{ roleKey(m.role) | translate }}</span>
              </span>
              @if (m.company.id === active.id) {
                <mat-icon class="company-menu__check" fontSet="uicon-rr" fontIcon="fi-rr-check" aria-hidden="true" />
              }
            </button>
          }
        </div>
      </ng-template>
    } @else {
      <div class="company-trigger is-static">
        <ng-container
          [ngTemplateOutlet]="identity"
          [ngTemplateOutletContext]="{ $implicit: active, switchable: false }"
        />
      </div>
    }
  </div>

  <ng-template #identity let-active let-switchable="switchable">
    <span class="company-avatar">
      @if (active.logo; as logo) {
        <img class="company-logo" [src]="logo.medium" [alt]="active.name" />
      } @else {
        <span class="company-initial" aria-hidden="true">{{ initial() }}</span>
      }
    </span>

    @if (!collapsed()) {
      <span class="company-text">
        <span class="company-overline">{{ 'sidebar.workspace' | translate }}</span>
        <span class="company-name">{{ active.name ?? ('auth.select_company.unnamed' | translate) }}</span>
      </span>

      @if (switchable) {
        <mat-icon
          class="company-chevron"
          [class.is-open]="menuOpen()"
          fontSet="uicon-rr"
          fontIcon="fi-rr-angle-small-down"
          aria-hidden="true"
        />
      }
    }
  </ng-template>
}
